<div class="container" fxLayout="column">
    <ng-container *ngFor="let thermostat of thermostats">
        <div fxLayout="row wrap" fxLayoutGap="25px" fxLayoutGap.lt-md="0px" fxLayout.lt-md="column">
            <home-temp-gauge  fxFlex="1 1" *ngIf="thermostat.name" [deviceName]=thermostat.name
            [temperature]=thermostat.temperature [humidity]=thermostat.humidity [gaugeNumber]=thermostat.gaugeNumber>
        </home-temp-gauge>
        </div>
    </ng-container>
</div>
